export const SET_CONFIGURED_TURBINES = "SET_CONFIGURED_TURBINES";
export const SHOW_CONFIRMATION_DIALOG = "SHOW_CONFIRMATION_DIALOG";
export const HIDE_CONFIRMATION_DIALOG = "HIDE_CONFIRMATION_DIALOG";
export const SET_CONFIRMATION_DIALOG_STATE = "SET_CONFIRMATION_DIALOG_STATE";
export const SET_SELECTED_REFERENCE_TURBINE = "SET_SELECTED_REFERENCE_TURBINE";
export const SET_SELECTED_TURBINES = "SET_SELECTED_TURBINES";
export const SET_SELECT_ALL_TURBINES = "SET_SELECT_ALL_TURBINES";
export const SET_TURBINE_SEARCH = "SET_TURBINE_SEARCH";
export const RESET_STATES = "RESET_STATES";
